import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {} from '../../util/ContractAdminUtils';
import { useSelector } from '../../components/common/react-redux-hooks';

const CASummaryEntThirdSectInfo = ({ propCodeId }) => {
  const { propCodes } = useSelector(state => ({
    propCodes: state.contractAdmin.propCodes,
  }));
  const [selectedPropCodes, setSelectedPropCodes] = useState([]);
  useEffect(() => {
    const selectedMarket = propCodes.length
      ? propCodes.filter(obj => propCodeId.includes(obj.id))
      : [];
    setSelectedPropCodes(selectedMarket);
  }, []);
  return (
    <React.Fragment>
      <div className="ent-section-header-codes">
        <div>
          <span className="summary-sp-col">Prop Codes</span>
        </div>
      </div>
      {selectedPropCodes.length > 0 &&
        selectedPropCodes.map(item => {
          const title = `${item.propCodeDescription}(${item.propCode})`;
          return (
            <div className="access-codes-list" title={title}>
              <span>
                {item.propCodeDescription}
                {`(${item.propCode})`}
              </span>
            </div>
          );
        })}
    </React.Fragment>
  );
};

CASummaryEntThirdSectInfo.propTypes = {
  propCodeId: PropTypes.arrayOf(PropTypes.object),
};

export default CASummaryEntThirdSectInfo;
